import PageLayout from "@/components/feature/PageLayout";
import ScrollReveal from "@/components/base/ScrollReveal";

import { blogPosts } from "@/mocks/blogPosts";

const sitemapSections = [
  {
    title: "Main Pages",
    items: [
      { label: "Home", href: "/" },
      { label: "About Us", href: "/about" },
      { label: "Find Your Therapist", href: "/therapists" },
      { label: "Contact", href: "/contact" },
      { label: "Blog", href: "/blog" },
      { label: "Site Map", href: "/sitemap" },
    ],
  },
  {
    title: "Services",
    items: [
      { label: "Individual Therapy", href: "/individual-therapy" },
      { label: "Child Therapy", href: "/child-therapy" },
      { label: "Couples Therapy", href: "/couples-therapy" },
      { label: "Teen Therapy", href: "/teen-therapy" },
      { label: "Group Therapy", href: "/group-therapy" },
    ],
  },
  {
    title: "Getting Started",
    items: [
      { label: "How It Works", href: "/#how-it-works" },
      { label: "Rates & Insurance", href: "/full-pricing" },
      { label: "FAQ", href: "/#faq" },
      { label: "All Blog Articles", href: "/blog/all" },
    ],
  },
  {
    title: "Legal & Information",
    items: [
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms & Conditions", href: "/terms-conditions" },
      { label: "Good Faith Estimate", href: "/good-faith-estimate" },
    ],
  },
  {
    title: "Blog Articles",
    items: blogPosts.map((p) => ({
      label: p.title,
      href: `/blog/${p.slug}`,
    })),
  },
  {
    title: "External Resources",
    items: [
      { label: "Full Blog", href: "https://www.perspectivetherapyny.com/blog-perspective-therapy-larchmont-new-york", external: true },
      { label: "Store", href: "https://thehealingspree.com", external: true },
    ],
  },
];

export default function Sitemap() {
  return (
    <>
      <title>Site Map | Perspective Therapy Larchmont NY</title>
      <meta name="description" content="Complete site map for Perspective Therapy. Navigate all pages including services, therapists, pricing, and contact information." />
      <PageLayout>
        <section className="w-full pt-32 pb-10 md:pt-40 md:pb-16" style={{ background: "linear-gradient(180deg, #F8F5EE 0%, #F5F1E8 100%)" }}>
          <div className="w-full px-6 md:px-12 lg:px-20">
            <ScrollReveal variant="fadeIn" delay={0}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-5 h-[2px] rounded-full" style={{ background: "linear-gradient(90deg, #6B742F, #B4A6E3)" }} />
                <span className="font-manrope text-[13px] font-semibold tracking-widest uppercase" style={{ color: "#6B742F" }}>
                  Site Map
                </span>
              </div>
            </ScrollReveal>
            <ScrollReveal variant="fadeUp" delay={80}>
              <h1 className="font-fraunces text-[#2B2B2B] text-4xl md:text-5xl font-light leading-snug mb-5">
                Navigate{" "}
                <em className="not-italic" style={{ color: "#7D54FC" }}>
                  Perspective Therapy
                </em>
              </h1>
            </ScrollReveal>
            <ScrollReveal variant="fadeUp" delay={160}>
              <p className="font-manrope text-[#2B2B2B]/78 text-[15px] leading-relaxed max-w-lg">
                A complete list of every page on our website. Find what you are looking for quickly.
              </p>
            </ScrollReveal>
          </div>
        </section>

        <section className="w-full py-16 md:py-24" style={{ background: "linear-gradient(180deg, #F5F1E8 0%, #EEE8DA 100%)" }}>
          <div className="w-full px-6 md:px-12 lg:px-20">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
              {sitemapSections.map((section, i) => (
                <ScrollReveal key={section.title} variant="fadeUp" delay={i * 80} threshold={0.06}>
                  <div className="rounded-2xl border bg-white/80 overflow-hidden" style={{ borderColor: "rgba(203,191,175,0.30)" }}>
                    <div className="h-[3px] w-full" style={{ background: "linear-gradient(90deg, #6B742F, #B4A6E3)" }} />
                    <div className="p-6 md:p-7">
                      <h3 className="font-fraunces text-[#2B2B2B] text-lg font-medium mb-5">{section.title}</h3>
                      <ul className="flex flex-col gap-2.5">
                        {section.items.map((item) => (
                          <li key={item.label}>
                            <a
                              href={item.href}
                              className="inline-flex items-center gap-1.5 font-manrope text-[14px] text-[#2B2B2B]/75 hover:text-[#2B2B2B] transition-colors cursor-pointer"
                              target={item.external ? "_blank" : undefined}
                              rel={item.external ? "nofollow noopener noreferrer" : undefined}
                            >
                              {item.label}
                              {item.external && <i className="ri-external-link-line text-xs text-[#2B2B2B]/40"></i>}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>
      </PageLayout>
    </>
  );
}
